import { motion } from "motion/react"

const SERVICE_ICONS: Record<string, string> = {
  web_dev: "fa-code",
  mobile: "fa-mobile-screen",
  desktop: "fa-desktop",
  security: "fa-shield-halved",
  seo: "fa-chart-line",
  ai: "fa-brain",
}

interface ServiceCardProps {
  serviceKey: string
  title: string
  description: string
  index: number
}

export default function ServiceCard({
  serviceKey,
  title,
  description,
  index,
}: ServiceCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="group relative p-6 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl hover:border-violet-500/30 hover:bg-white/[0.07] transition-all duration-300"
    >
      {/* Gradient highlight on hover */}
      <div className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gradient-to-br from-violet-600/5 to-cyan-600/5" />

      <div className="relative">
        <div className="w-10 h-10 mb-4 flex items-center justify-center rounded-lg bg-violet-500/10 text-violet-400">
          <i className={`fa-solid ${SERVICE_ICONS[serviceKey] ?? "fa-star"} text-base`} />
        </div>
        <h3 className="mb-2 text-base font-semibold text-white">{title}</h3>
        <p className="text-sm text-slate-400 leading-relaxed">{description}</p>
      </div>
    </motion.div>
  )
}
